import { render } from "./SyncSpinner.vue?vue&type=template&id=08d854fe&scoped=true"
import script from "./SyncSpinner.vue?vue&type=script&lang=js"
export * from "./SyncSpinner.vue?vue&type=script&lang=js"

import "./SyncSpinner.vue?vue&type=style&index=0&id=08d854fe&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d854fe"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
